import React, { Component, PropTypes } from 'react';
import './Exeggcute.scss';

class Exeggcute extends Component {
  render() {
    return (
      <div className="pokemon">
        <div className="exeggcute">
          <div className="head">

          </div>
          <div className="body">

          </div>
        </div>
      </div>
    );
  }
}

export default Exeggcute;



/** WEBPACK FOOTER **
 ** ./source/102-exeggcute/Exeggcute.js
 **/